import { ActivatedRoute, Router } from '@angular/router';
import { Component, HostListener, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { AlertService } from '../../../services/alert.service';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { LivecoAPIService } from 'src/app/services/liveco-api.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/dialog/confirm-dialog/confirm-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { AbstractControl, FormBuilder, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FormGroupComponent } from 'src/app/shared/pages/form-group/form-group.component';
import { LoaderService } from 'src/app/services/loader.service';
import { AuthService } from 'src/app/services/auth.service';
import { NgClass } from '@angular/common';
import { ResetPasswordForm } from '../../components/reset-password/reset-password.form';


@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.page.html',
    styleUrls: ['./reset-password.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, ResetPasswordForm]
})
export class ResetPasswordPage extends FormGroupComponent<any> implements OnInit {
    protected dialog = inject(MatDialog);
    protected s_liveco = inject(LivecoAPIService);
    protected translate = inject(TranslateService);
    private fb = inject(FormBuilder);


    isLoading: boolean = false;
   
    constructor() {
        super();
    }

    public changeFormLoading = (e: boolean): void => {
        this.isLoading = e;
    };
}

